import React, { Component } from 'react';
import { IconButton } from '..';
import { connect } from 'react-redux';
import { accessoriesIcon } from '../../../style/images';
import { translate, getLanguages } from '../../services';
import { BomItem, ConfiguratorPage } from '../../site';
import { assignmentDecision, getAssignedValue, deflateModelVariables, checkIsBomItemMain, findInPropertyPath,getAccessories } from '../../util';
import { PropTypes } from 'prop-types';
import { sessionStore } from '../../services';
import { combineDispatchers, configuratorDispatcher, 
  popupDispatcher,identityState,siteSettingsState, combineStates, analyticsDispatcher, showConfigureDispatcher, currentPageDispatcher, currentPageState,nodeState,filterDispatcher,productsDispatcher, repositoryState} from '../../store';
  import { Redirect } from 'react-router-dom/cjs/react-router-dom';
import classNames from 'classnames';
import { Box, IconButton as MuiIconButton } from '@mui/material';
import deepStrictEqual from 'deep-strict-equal';

const removeExcessPropertiesFromProduct = product => ({ 
  ...product, 
  preset: product.bomItems?.select( b => ({ variableName: b.identifier?.split('.').slice(1).join('.')?b.identifier?.split('.').slice(1).join('.'):b.identifier, valueName: b.value?.name?b.value?.name:b.name,looseacc:b.looseacc,configuredAcc:b.configuredAcc })), 
  allSatisfied: undefined 
});

export class ConfigureButtonComponent extends Component {
getMissingProduct(props){
    let code;
    if(props?.product?.fgProduct && props?.product?.fgProduct[0]){
      code=props.product.fgProduct[0].Name;
      props.getProduct(code);
    }}
  clearConfiguration( name ) {
    // reset any configurations as this gets called from the reducer, I have to clear it through timeout hack
    name && setTimeout( () => this.props.removeConfiguration( { name } ), 0 );
  }

  
  goToModelConfiguratorPage = () => {
    const { product, node } = this.props;
    const root = window.location.href.split( '/#' )[0];
    const selected = !product.nodeCID && findInPropertyPath( node, 'children', child => child.configuratorName === product.materialName ).firstOrDefault();
    const nodeCID = product.nodeCID || selected?.nodeId || selected?.uuid || product.materialName;
    const url = `${root}/#/reconfigure/${nodeCID}`;
    this.props.loadProductFromModelConfigurator({...product, nodeCID : nodeCID});
    window.location.href = url;
  }

  openConfigurationPopup = () => {
    if(this.props.currentPage.currentPage!=="configuratorPage"){
      this.props.setPage("configuratorPage")
    }
    //for mobile
    this.props.closeDialog&&this.props.closeDialog()
    const { fromCart, onClick, product,items ,fromSearch } = this.props;
    const { modelToLoad, properties, filterSelectors, selector } = this.context;
    const oldProduct = { ...product };
    this.getMissingProduct(this.props)
    let title = `${translate( 'Configure {product}', { product: product.name} )}`;
    var filterselector_search={}
    var flag=false;
    let selectorName=items.firstOrDefault( selector => selector.name === 'Emax 2')
    if(product.properties.find(p=>p.name=="Emax 2 Fixed Parts")){
      selectorName=items.firstOrDefault( selector => selector.name === 'Emax 2 Fixed Parts')
    }
    if( fromCart ){
      const additionalProduct = product.additionalProducts && product.additionalProducts[0];
      if(additionalProduct){
        title = `${translate( 'Configure {product}', { product: product.code})} + ${additionalProduct.code}`;
      }
    }else{
      const additionalProduct = product.bomItems?.firstOrDefault(x => x.identifier?.indexOf('FixedPart') > 0);
      if( additionalProduct ){
        title = `${translate( 'Configure {product}', { product: product.code})} + ${additionalProduct.value.name}`;
      }
    }
    if(product.materialName.includes('EMAX2') && !filterSelectors ){
      this.props.getFilterSelectors( selectorName, this.props.user,false,false,true,true,fromCart ).then((filterSelectors_response)=>
      {filterselector_search={...filterSelectors_response};    
    onClick && onClick();
    const FS=filterselector_search?.data?.map(f=>{if(f.identifier=="GrpSelector.varLooseSensor"){f.values[0].isSelected=true; return f} 
    else if(f.identifier=="Selector.varDummy"){f.values[0].isSelected=true; return f} else return f})
    this.props.showConfigureComponent(<ConfiguratorPage  
          properties={ properties || product.usCodeProps } 
          modelToLoad={ modelToLoad } 
          product={ removeExcessPropertiesFromProduct( product ) } 
          fromCart={ fromCart } 
          oldProduct={ oldProduct } 
          isPopup 
          selector
          filterSelectors={ filterSelectors || FS }
          fromSearch={fromSearch} />,
    )})
    this.props.captureEvent( 'configured-items', 'family', product.materialName, ['commonTracker'] );
      //ga4
      const additionalProduct = product.bomItems?.firstOrDefault(x => x.identifier.indexOf('FixedPart') > 0);
      if (this.props.currentPage.currentPage!="cartPage") { 
      const eventString = product.bomItems?(";"+product.bomItems?.reduce((s,b)=>s!=""?s+","+b.value.name:b.value.name,"")):"";
      dataLayer.push({
        'event': 'configured_items',
        event_action:'family',
        event_label :(additionalProduct?"FP+MP:":"")+product.name.concat(eventString).concat(':').concat(product.materialName),
        event_instance:this.props.siteSettings.properties.GaInstance,
        event_country: this.props.siteSettings.properties.GaCountry,
        location_url:window.location.href
      })
    }
    else { //configuration from cart
      const cartProduct = product.configuration&&product.configuration.model&&product.configuration.model.children[0]&&product.configuration.model.children[0].variables?product.configuration.model.children[0].variables:""; //for retrieving accessories FP
      const cartProductMP = product.additionalProducts&&product.additionalProducts.length>0&&product.additionalProducts[0].configuration? product.additionalProducts[0].configuration?.model.children[0].variables:""; //for retrieving accessories MP
      const finalProd=cartProduct!=""?cartProduct.reduce((s,b)=>b.assignedValue!=null? (s!=""? s+","+b.assignedValue.name: b.assignedValue.name):s,""):""; //create string accessories FP
      const finalProdMP=product.additionalProducts&&product.additionalProducts.length>0 && cartProductMP!=""?cartProductMP.reduce((s,b)=>b.assignedValue!=null? (s!=""? s+","+b.assignedValue.name: b.assignedValue.name):s,""):""; //create string accessories MP
      const eventString = (product.additionalProducts&&product.additionalProducts.length>0?"FP+MP:":"")+product.name+((finalProd!=""?";"+finalProd:"")+(product.additionalProducts&&product.additionalProducts.length>0?("-"+product.additionalProducts[0].name+(finalProdMP!=""?";"+finalProdMP:"")):""))+':'+(product.materialName);
      dataLayer.push({ //for cart
        'event': 'configured_items',
        event_action:'family',
        event_label :eventString,
        event_instance:this.props.siteSettings.properties.GaInstance,
        event_country: this.props.siteSettings.properties.GaCountry,
        location_url:window.location.href
      })
    }}
    
    else{
      flag=true
    }
    flag && this.props.showConfigureComponent( 
       <ConfiguratorPage  
          properties={ properties || product.usCodeProps } 
          modelToLoad={ modelToLoad } 
          product={ removeExcessPropertiesFromProduct( product ) } 
          fromCart={ fromCart } 
          oldProduct={ oldProduct } 
          isPopup 
          selector
          filterSelectors={ filterSelectors }
          fromSearch={fromSearch} />,
    );
  }

  getAssignmentCount() {
    const { product, products,fromCart } = this.props;
    const siteSettings = sessionStore.get( 'siteSettings' );
    if ( !product ) {
      return null;
    }
    let additional_acc=[]
    const mainaccessories=getAccessories( product, fromCart );
    if(product.looseadditionalProduct && product.looseadditionalProduct.length > 0 ){
      additional_acc = getAccessories( product.looseadditionalProduct.firstOrDefault(),fromCart );
    }
    const acc_list=mainaccessories.concat(additional_acc)
    //if with new acc_list FG identified
    if(acc_list && acc_list.length>0 && product.superCodeLSO && product.superCodeLSO!="待开"&&product.superCodeLSO!="-"){
      return <span className="floating-NST">{ acc_list.length * product.amount }</span>;
    }
    if ( product.bomItems && product.bomItems.length ) {
      //forward checking
      if(product.configurableProduct && product.superCodeLSO!="待开"&&product.superCodeLSO!="-"){
        return product.bomItems.any(b=>b.configuredAcc==false)?<span className="floating">{ product.bomItems.length * product.amount }</span>:<span className="floating-NST">{ product.bomItems.length * product.amount }</span>;
      }
      else{
        return <span className="floating">{ product.bomItems.length * product.amount }</span>;
      }
    }

    if ( !product.configuration ) {
      return null;
    }

    const lang = getLanguages().first();
    //This is to handle the wiringDiagramComponents to be excluded in the count of accessories
    let quantity = 0;
    let isBomItemMain = checkIsBomItemMain(product.configuration);
    if( product.configuration.bomComponents?.length > 0 ){
      product.configuration.bomComponents.forEach(filter => {
        if(Number(filter.itemNumber) >= 9000 && !filter.component.includes('1SDA')){
          // do nothing here, just skip the wiring diagram components from bom components count
        }
        else if(isBomItemMain){
          // if(product.configuration.materialKey == siteSettings.properties.materialKey){
            if(siteSettings.properties?.modelConfigurators && siteSettings.properties?.modelConfigurators?.includes(product.configuration.materialKey)){
            quantity = quantity + parseInt(filter.quantity * product.amount);
          }
          else{
            quantity = quantity + parseInt(filter.quantity);
          }
        }
        else {
          // quantity = quantity + parseInt(filter.quantity * product.amount);
          quantity = quantity + parseInt( product.amount);
        }
      });
    }
 quantity=quantity+(additional_acc?.length* product.amount);
    
    let NST_acc=[]
    if(product.bom && product.bom.length>0){
      NST_acc=product.bom.map(b=> b.name)
    }
    if ( product.configuration?.bomComponents?.length ) {
          if(!deepStrictEqual(acc_list,NST_acc)){
          return <span className="floating">{ quantity }</span>
          }
          return <span className="floating-NST">{ quantity }</span>
    }
    if( product.importAccessories?.length > 0 ){
      quantity = product.importAccessories.reduce(
        (acc, c) => acc += ( c.quantity != product.amount ) ? product.amount 
        : parseInt(c.quantity || product.amount), 0);
      // return <span className="floating">
      //     { quantity > 0 ? quantity : (product.importAccessories.length * product.amount) }
      //   </span>
      return quantity > 0 ? quantity : (product.importAccessories.length * product.amount)}
    
    if(!checkIsBomItemMain(product.configuration)) {
    //This is to handle the length of missing bomComponents/ accessories in the accessoryView
    const missingBomComponentsInView = product.configuration.assignments?.
      filter(assign => assign.key === null && Object.keys(products).indexOf(assign.value) > -1);
    const accessories = product.configuration && deflateModelVariables( product.configuration.model );
    const userAssignedAccessories = accessories.filter( accessory => 
      assignmentDecision( product.configuration.productModelType, lang )( accessory ) && 
      getAssignedValue( accessory ) !== product.configuration.product.name ).concat(additional_acc);
if(!deepStrictEqual(acc_list,NST_acc)){
      return userAssignedAccessories.length > 0 && 
    <span className="floating"> 
      { (userAssignedAccessories.length + missingBomComponentsInView.length) * product.amount }
    </span>;
      }
     return userAssignedAccessories.length > 0 && 
    <span className="floating-NST"> 
      { (userAssignedAccessories.length + missingBomComponentsInView.length) * product.amount }
    </span>;
    }
    return <span >0</span>
  }
  render() {
    const { disabled, product } = this.props;
    const hidden = (!product.isConfigurable && ( !product.materialName || product.materialName === product.name )) || product.hideConfigureButton;
    const className = classNames("configure-button","round-button",{"icon-bg-black":this.props.fromCart})
    //Change done for fixing css in search of product
    // if(hidden || disabled){
    //   return null;
    // }
    return this.props.mobileCartItem?<div className="items"  onClick={ this.openConfigurationPopup }>
    {/* <MuiIconButton><Box component="img" src={this.props.icon} sx={{width:"20px", height:"20px"}}></Box></MuiIconButton> */}
    <IconButton 
      className={className} 
      tooltip={ translate( 'Configure' ) }
      icon={ this.props.icon?this.props.icon:accessoriesIcon } 
      onClick={ (product.isBomItemMain || checkIsBomItemMain(product.configuration)) ? this.goToModelConfiguratorPage : this.openConfigurationPopup } 
      detailComponent={ this.getAssignmentCount() } 
      disabled={ disabled } 
      hidden={ hidden }
    />
    <span>{translate("Configure")}</span>
    </div>
    :<IconButton 
      className={className} 
      tooltip={ translate( 'Configure' ) }
      icon={ this.props.icon?this.props.icon:accessoriesIcon } 
      onClick={ (product.isBomItemMain || checkIsBomItemMain(product.configuration)) ? this.goToModelConfiguratorPage : this.openConfigurationPopup } 
      detailComponent={ this.getAssignmentCount() } 
      disabled={ disabled } 
      hidden={ hidden }
    />;
  }
}

ConfigureButtonComponent.propTypes = {
  disabled: PropTypes.bool,
  fromCart: PropTypes.bool,
  onClick: PropTypes.func,
  product: PropTypes.shape( {
    configuration: PropTypes.shape( {} ),
    isConfigurable: PropTypes.bool,
    materialName: PropTypes.string,
    name: PropTypes.name,
    amount: PropTypes.number
  } ),
  products: PropTypes.shape( {} ),
  removeConfiguration: PropTypes.func.isRequired,
  setPopup: PropTypes.func.isRequired,
  captureEvent: PropTypes.func.isRequired
};

ConfigureButtonComponent.contextTypes = {
  modelToLoad: PropTypes.string,
  properties: PropTypes.shape( {} ),
  filterSelectors: PropTypes.array
};

export const ConfigureButton = connect( combineStates(currentPageState, siteSettingsState,identityState,nodeState,repositoryState( 'selector' )), combineDispatchers(currentPageDispatcher, configuratorDispatcher, popupDispatcher, analyticsDispatcher, showConfigureDispatcher,filterDispatcher,productsDispatcher ) )( ConfigureButtonComponent );
